import styled from 'styled-components'

export const Outer = styled.section`
  background-color: ${({ bgColor }) => bgColor || '#edf3ff'};
  .gatsby-image-wrapper {
    @media only screen and (max-width: 600px) {
      height: 1400px;
    }
  }
`
export const Hat = styled.div`
  background-color: ${({ inverse, theme, accent }) =>
    accent || (inverse ? theme.colors.secondary : theme.colors.primary)};
  height: 6px;
  width: 106px;
  margin-bottom: 2rem;
  position: absolute;
  top: 36%;
  @media only screen and (max-width: 582px) {
    top: 25%;
  }
`

export const TextReplaceWrapper = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  padding: 8rem 2rem 4rem;
  p {
    font-size: 48px;
    margin-right: 12px;
    @media only screen and (max-width: 1200px) {
      font-size: 40px;
    }

  }
  .static {
    transition: transition: all .3s;
  }

  .replacement {
    color: ${({ theme }) => theme.colors.primary};
    width: 0;
    height: 0;
    opacity: 0;
  }
  .hidden {
    visibility: hidden;
    opacity: 0 !important;
    transition: visibility 0s 1s, opacity 0.4s linear;
  }

  .visible {
    display: block;
    visibility: visible;
    opacity: 1;
    transition: opacity 0.4s linear;
  }

  .move-left {
    transform: translateX(-65%);
    transition: all 2s;
  }

  @-webkit-keyframes fadeOutDown {
    0% {
      width: auto;
      height: auto;
      opacity: 1;
      -webkit-transform: translateY(0);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(-100);
    }
  }

  @keyframes fadeOutDown {
    0% {
      width: auto;
      height: auto;
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(100px);
      width: 0;
      height: 0;
      
    }
  }

  @-webkit-keyframes fadeInUp {
    0% {
      width: auto;
      opacity: 0;
      -webkit-transform: translateY(100px);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    0% {
      width: auto;
      height: auto;
      opacity: 0;
      transform: translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @-webkit-keyframes fadeInLeft {
    0% {
      width: auto !important;
      height: auto !important;
      opacity: 0;
      -webkit-transform: translateX(50px);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
    }
  }

  @keyframes fadeInLeft {
    0% {
      width: auto !important;
      height: auto !important;
      opacity: 0;
      transform: translateX(50px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @-webkit-keyframes fadeOutRight {
    0% {
      opacity: 1;
      -webkit-transform: translateX(0);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateX(50px);
    }
  }

  @keyframes fadeOutRight {
    0% {
      opacity: 1;
      transform: translateX(0);
    }
    100% {
      opacity: 0;
      transform: translateX(50px);
    }
  }

  .fadeOutRight {
    width: 0;
    height: 0;
    -webkit-animation-name: fadeOutRight;
    animation-name: fadeOutRight;
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  .fadeInLeft {
    width: auto !important;
    height: auto !important;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  .fadeInUp {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
    animation-duration: 0.8s;
    animation-fill-mode: both;
  }
  .fadeOutDown {
    position: absolute;
    -webkit-animation-name: fadeOutDown;
    animation-name: fadeOutDown;
    animation-duration: .8s;
    animation-fill-mode: both;
  }
`

export const Cross = styled.div`
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .line {
    position: absolute;
    width: 80%;
    top: 1.875rem;
    right: 0;
    height: 5px;
    background-color: ${({ theme }) => theme.colors.primary};
    transform: rotate(20deg);
  }
  .right {
    transform: rotate(-20deg);
  }
`
